module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui stackable three column grid"
  }, _vm._l((_vm.items), function(good) {
    return _c('div', {
      staticClass: "column"
    }, [_vm._m(1, true)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ui container",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "ui right floated green button",
    on: {
      "click": _vm.goToTopDiscountGoodsPage
    }
  }, [_vm._v("Apskatīt vairāk "), _c('i', {
    staticClass: "arrow right icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "ui dividing header"
  }, [_c('i', {
    staticClass: "gift icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n      Akcijas preces\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui fluid card"
  }, [_c('div', [_c('img', {
    staticClass: "ui small centered image",
    attrs: {
      "src": "https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_255,c_lfill/product/1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "header",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Memory Water 18,9l")]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "ui tag labels"
  }, [_c('a', {
    staticClass: "ui custom_brown label"
  }, [_vm._v("\n              Cena: 10.00 €\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "ui green label"
  }, [_vm._v("\n              Drošības nauda: 10.99 €\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n            Strukturēts ūdens 18,9l ar piegādi. Cena par litru tikai ~0,30 EUR. Jo vairāk pudeles vienā reizē pasūta, jo lielāka atlaide tiks automātiski piemērota. Pērkot 2 pud: 5,56 EUR/pud. Drošības nauda 8 EUR/pud.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "ui bottom attached button"
  }, [_c('i', {
    staticClass: "add icon"
  }), _vm._v(" Pievienot\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21d6b938!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeDiscountedGoods.vue
// module id = 327
// module chunks = 1